module.exports = __webpack_public_path__ + "static/img/keep_package_desc.559b6b4a.png";